export default __webpack_public_path__ + "static/media/absel-site.4a16b419.png";